{
  "account.add_or_remove_from_list": "Aghjunghje o toglie da e liste",
  "account.badges.bot": "Bot",
  "account.badges.group": "Gruppu",
  "account.block": "Bluccà @{name}",
  "account.block_domain": "Piattà u duminiu {domain}",
  "account.blocked": "Bluccatu",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.disable_notifications": "Ùn mi nutificate più quandu @{name} pubblica qualcosa",
  "account.edit_profile": "Mudificà u prufile",
  "account.enable_notifications": "Nutificate mi quandu @{name} pubblica qualcosa",
  "account.endorse": "Fà figurà nant'à u prufilu",
  "account.follow": "Siguità",
  "account.followers": "Abbunati",
  "account.followers.empty": "Nisunu hè abbunatu à st'utilizatore.",
  "account.follows.empty": "St'utilizatore ùn seguita nisunu.",
  "account.hide_reblogs": "Piattà spartere da @{name}",
  "account.link_verified_on": "A prupietà di stu ligame hè stata verificata u {date}",
  "account.locked_info": "U statutu di vita privata di u contu hè chjosu. U pruprietariu esamina manualmente e dumande d'abbunamentu.",
  "account.media": "Media",
  "account.mention": "Mintuvà @{name}",
  "account.mute": "Piattà @{name}",
  "account.muted": "Piattatu",
  "account.posts": "Statuti",
  "account.report": "Palisà @{name}",
  "account.share": "Sparte u prufile di @{name}",
  "account.show_reblogs": "Vede spartere da @{name}",
  "account.unblock": "Sbluccà @{name}",
  "account.unblock_domain": "Ùn piattà più {domain}",
  "account.unendorse": "Ùn fà figurà nant'à u prufilu",
  "account.unfollow": "Ùn siguità più",
  "account.unmute": "Ùn piattà più @{name}",
  "account_note.placeholder": "Senza cummentariu",
  "alert.rate_limited.message": "Pruvate ancu dop'à {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ghjettu limitatu",
  "alert.unexpected.message": "Un prublemu inaspettatu hè accadutu.",
  "alert.unexpected.title": "Uups!",
  "announcement.announcement": "Annunziu",
  "attachments_list.unprocessed": "(micca trattata)",
  "boost_modal.combo": "Pudete appughjà nant'à {combo} per saltà quessa a prussima volta",
  "bundle_column_error.retry": "Pruvà torna",
  "bundle_modal_error.close": "Chjudà",
  "bundle_modal_error.retry": "Pruvà torna",
  "column.blocks": "Utilizatori bluccati",
  "column.bookmarks": "Segnalibri",
  "column.community": "Linea pubblica lucale",
  "column.directory": "Percorre i prufili",
  "column.domain_blocks": "Duminii piattati",
  "column.follow_requests": "Dumande d'abbunamentu",
  "column.home": "Accolta",
  "column.lists": "Liste",
  "column.mutes": "Utilizatori piattati",
  "column.notifications": "Nutificazione",
  "column.pins": "Statuti puntarulati",
  "column.public": "Linea pubblica glubale",
  "column_back_button.label": "Ritornu",
  "column_header.hide_settings": "Piattà i parametri",
  "column_header.moveLeft_settings": "Spiazzà à manca",
  "column_header.moveRight_settings": "Spiazzà à diritta",
  "column_header.pin": "Puntarulà",
  "column_header.show_settings": "Mustrà i parametri",
  "column_header.unpin": "Spuntarulà",
  "community.column_settings.local_only": "Solu lucale",
  "community.column_settings.media_only": "Solu media",
  "community.column_settings.remote_only": "Solu distante",
  "compose_form.direct_message_warning_learn_more": "Amparà di più",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "U vostru contu ùn hè micca {locked}. Tuttu u mondu pò seguitavi è vede i vostri statuti privati.",
  "compose_form.lock_disclaimer.lock": "privatu",
  "compose_form.placeholder": "À chè pensate?",
  "compose_form.poll.duration": "Durata di u scandagliu",
  "compose_form.poll.switch_to_multiple": "Cambià u scandagliu per accittà parechje scelte",
  "compose_form.poll.switch_to_single": "Cambià u scandagliu per ùn accittà ch'una scelta",
  "compose_form.spoiler.marked": "Testu piattatu daret'à un'avertimentu",
  "compose_form.spoiler.unmarked": "Testu micca piattatu",
  "confirmation_modal.cancel": "Annullà",
  "confirmations.block.confirm": "Bluccà",
  "confirmations.delete.confirm": "Toglie",
  "confirmations.delete.message": "Site sicuru·a che vulete sguassà stu statutu?",
  "confirmations.delete_list.confirm": "Toglie",
  "confirmations.delete_list.message": "Site sicuru·a che vulete toglie sta lista?",
  "confirmations.discard_edit_media.confirm": "Scartà",
  "confirmations.logout.confirm": "Scunnettassi",
  "confirmations.logout.message": "Site sicuru·a che vulete scunnettà vi?",
  "confirmations.mute.confirm": "Piattà",
  "confirmations.redraft.confirm": "Sguassà è riscrive",
  "confirmations.unfollow.confirm": "Disabbunassi",
  "conversation.delete": "Sguassà a cunversazione",
  "conversation.mark_as_read": "Marcà cum'è lettu",
  "conversation.open": "Vede a cunversazione",
  "conversation.with": "Cù {names}",
  "directory.federated": "Da u fediversu cunisciutu",
  "directory.local": "Solu da {domain}",
  "directory.new_arrivals": "Ultimi arrivi",
  "directory.recently_active": "Attività ricente",
  "embed.instructions": "Integrà stu statutu à u vostru situ cù u codice quì sottu.",
  "embed.preview": "Hà da parè à quessa:",
  "emoji_button.activity": "Attività",
  "emoji_button.custom": "Persunalizati",
  "emoji_button.flags": "Bandere",
  "emoji_button.food": "Manghjusca è Bienda",
  "emoji_button.label": "Mette un'emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Ùn c'hè nunda! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Oggetti",
  "emoji_button.people": "Parsunaghji",
  "emoji_button.recent": "Assai utilizati",
  "emoji_button.search": "Cercà...",
  "emoji_button.search_results": "Risultati di a cerca",
  "emoji_button.symbols": "Simbuli",
  "emoji_button.travel": "Lochi è Viaghju",
  "empty_column.account_suspended": "Contu suspesu",
  "empty_column.account_timeline": "Nisun statutu quì!",
  "empty_column.account_unavailable": "Prufile micca dispunibule",
  "empty_column.blocks": "Per avà ùn avete bluccatu manc'un utilizatore.",
  "empty_column.bookmarked_statuses": "Ùn avete manc'un segnalibru. Quandu aghjunghjerate unu, sarà mustratu quì.",
  "empty_column.community": "Ùn c'hè nunda indè a linea lucale. Scrivete puru qualcosa!",
  "empty_column.domain_blocks": "Ùn c'hè manc'un duminiu bluccatu avà.",
  "empty_column.follow_requests": "Ùn avete manc'una dumanda d'abbunamentu. Quandu averete una, sarà mustrata quì.",
  "empty_column.hashtag": "Ùn c'hè ancu nunda quì.",
  "empty_column.home": "A vostr'accolta hè viota! Pudete andà nant'à {public} o pruvà a ricerca per truvà parsone da siguità.",
  "empty_column.list": "Ùn c'hè ancu nunda quì. Quandu membri di sta lista manderanu novi statuti, i vidarete quì.",
  "empty_column.mutes": "Per avà ùn avete manc'un utilizatore piattatu.",
  "empty_column.notifications": "Ùn avete ancu nisuna nutificazione. Interact with others to start the conversation.",
  "empty_column.public": "Ùn c'hè nunda quì! Scrivete qualcosa in pubblicu o seguitate utilizatori d'altri servori per empie a linea pubblica",
  "error.unexpected_crash.explanation": "In ragione d'un bug indè u nostru codice o un prublemu di cumpatibilità cù quessu navigatore, sta pagina ùn hè micca pussuta esse affissata currettamente.",
  "error.unexpected_crash.explanation_addons": "Sta pagina ùn hè micca pussuta esse affissata currettamente, prubabilmente per via d'un'estenzione di navigatore o d'un lugiziale di traduzione.",
  "error.unexpected_crash.next_steps": "Pruvate d'attualizà sta pagina. S'ellu persiste u prublemu, pudete forse sempre accede à Mastodon dapoi un'alltru navigatore o applicazione.",
  "error.unexpected_crash.next_steps_addons": "Pruvate di disattivà quelli è poi attualizà sta pagina. S'ellu persiste u prublemu, pudete forse sempre accede à Mastodon dapoi un'alltru navigatore o applicazione.",
  "errors.unexpected_crash.copy_stacktrace": "Cupià stacktrace nant'à u fermacarta",
  "errors.unexpected_crash.report_issue": "Palisà prublemu",
  "follow_request.authorize": "Auturizà",
  "follow_request.reject": "Righjittà",
  "follow_requests.unlocked_explanation": "U vostru contu ùn hè micca privatu, ma a squadra d'amministrazione di {domain} pensa chì e dumande d'abbunamentu di questi conti anu bisognu d'esse verificate manualmente.",
  "generic.saved": "Salvatu",
  "getting_started.heading": "Per principià",
  "hashtag.column_header.tag_mode.all": "è {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "senza {additional}",
  "hashtag.column_settings.select.no_options_message": "Nisuna sugestione trova",
  "hashtag.column_settings.select.placeholder": "Entrà l'hashtag…",
  "hashtag.column_settings.tag_mode.all": "Tutti quessi",
  "hashtag.column_settings.tag_mode.any": "Unu di quessi",
  "hashtag.column_settings.tag_mode.none": "Nisunu di quessi",
  "hashtag.column_settings.tag_toggle": "Inchjude tag addiziunali per sta colonna",
  "home.column_settings.show_reblogs": "Vede e spartere",
  "home.column_settings.show_replies": "Vede e risposte",
  "home.hide_announcements": "Piattà annunzii",
  "home.show_announcements": "Vede annunzii",
  "intervals.full.days": "{number, plural, one {# ghjornu} other {# ghjorni}}",
  "intervals.full.hours": "{number, plural, one {# ora} other {# ore}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} other {# minute}}",
  "keyboard_shortcuts.back": "rivultà",
  "keyboard_shortcuts.blocked": "per apre una lista d'utilizatori bluccati",
  "keyboard_shortcuts.boost": "sparte",
  "keyboard_shortcuts.column": "fucalizà un statutu indè una colonna",
  "keyboard_shortcuts.compose": "fucalizà nant'à l'area di ridazzione",
  "keyboard_shortcuts.description": "Descrizzione",
  "keyboard_shortcuts.down": "falà indè a lista",
  "keyboard_shortcuts.enter": "apre u statutu",
  "keyboard_shortcuts.federated": "per apre a linea pubblica glubale",
  "keyboard_shortcuts.heading": "Accorte cù a tastera",
  "keyboard_shortcuts.home": "per apre a linea d'accolta",
  "keyboard_shortcuts.hotkey": "Accorta",
  "keyboard_shortcuts.legend": "vede a legenda",
  "keyboard_shortcuts.local": "per apre a linea pubblica lucale",
  "keyboard_shortcuts.mention": "mintuvà l'autore",
  "keyboard_shortcuts.muted": "per apre a lista di l'utilizatori piattati",
  "keyboard_shortcuts.my_profile": "per apre u vostru prufile",
  "keyboard_shortcuts.notifications": "per apre a culonna di nutificazione",
  "keyboard_shortcuts.open_media": "per apre i media",
  "keyboard_shortcuts.pinned": "per apre a lista di statuti puntarulati",
  "keyboard_shortcuts.profile": "per apre u prufile di l'autore",
  "keyboard_shortcuts.reply": "risponde",
  "keyboard_shortcuts.requests": "per apre a lista di dumande d'abbunamentu",
  "keyboard_shortcuts.search": "fucalizà nant'à l'area di circata",
  "keyboard_shortcuts.spoilers": "per mustrà/piattà u campu CW",
  "keyboard_shortcuts.start": "per apre a culonna \"per principià\"",
  "keyboard_shortcuts.toggle_hidden": "vede/piattà u testu daretu à l'avertimentu CW",
  "keyboard_shortcuts.toggle_sensitivity": "vede/piattà i media",
  "keyboard_shortcuts.toot": "scrive un novu statutu",
  "keyboard_shortcuts.unfocus": "ùn fucalizà più l'area di testu",
  "keyboard_shortcuts.up": "cullà indè a lista",
  "lightbox.close": "Chjudà",
  "lightbox.next": "Siguente",
  "lightbox.previous": "Pricidente",
  "lists.delete": "Toglie a lista",
  "lists.edit": "Mudificà a lista",
  "lists.replies_policy.followed": "Tutti i vostri abbunamenti",
  "lists.replies_policy.list": "Membri di a lista",
  "lists.replies_policy.none": "Nimu",
  "load_pending": "{count, plural, one {# entrata nova} other {# entrate nove}}",
  "navigation_bar.blocks": "Utilizatori bluccati",
  "navigation_bar.bookmarks": "Segnalibri",
  "navigation_bar.domain_blocks": "Duminii piattati",
  "navigation_bar.filters": "Parolle silenzate",
  "navigation_bar.follow_requests": "Dumande d'abbunamentu",
  "navigation_bar.follows_and_followers": "Abbunati è abbunamenti",
  "navigation_bar.lists": "Liste",
  "navigation_bar.logout": "Scunnettassi",
  "navigation_bar.mutes": "Utilizatori piattati",
  "navigation_bar.preferences": "Preferenze",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} v'hà seguitatu",
  "notification.follow_request": "{name} vole abbunassi à u vostru contu",
  "notification.own_poll": "U vostru scandagliu hè compiu",
  "notification.reblog": "{name} hà spartutu u vostru statutu",
  "notification.status": "{name} hà appena pubblicatu",
  "notifications.clear": "Purgà e nutificazione",
  "notifications.clear_confirmation": "Site sicuru·a che vulete toglie tutte ste nutificazione?",
  "notifications.column_settings.alert": "Nutificazione nant'à l'urdinatore",
  "notifications.column_settings.follow": "Abbunati novi:",
  "notifications.column_settings.follow_request": "Nove dumande d'abbunamentu:",
  "notifications.column_settings.mention": "Minzione:",
  "notifications.column_settings.poll": "Risultati:",
  "notifications.column_settings.push": "Nutificazione Push",
  "notifications.column_settings.reblog": "Spartere:",
  "notifications.column_settings.show": "Mustrà indè a colonna",
  "notifications.column_settings.sound": "Sunà",
  "notifications.column_settings.status": "Statuti novi:",
  "notifications.filter.all": "Tuttu",
  "notifications.filter.boosts": "Spartere",
  "notifications.filter.follows": "Abbunamenti",
  "notifications.filter.mentions": "Minzione",
  "notifications.filter.polls": "Risultati di u scandagliu",
  "notifications.filter.statuses": "Messe à ghjornu di e persone chì siguitate",
  "notifications.grant_permission": "Auturizà.",
  "notifications.group": "{count} nutificazione",
  "notifications.mark_as_read": "Marcà tutte e nutificazione cum'è lette",
  "notifications.permission_denied": "Ùn si po micca attivà e nutificazione desktop perchè l'auturizazione hè stata ricusata",
  "notifications.permission_denied_alert": "Ùn pudete micca attivà e nutificazione nant'à l'urdinatore, perchè avete digià ricusatu a dumanda d'auturizazione di u navigatore",
  "notifications.permission_required": "Ùn si po micca attivà e nutificazione desktop perchè a l'auturizazione richiesta ùn hè micca stata data.",
  "notifications_permission_banner.enable": "Attivà e nutificazione nant'à l'urdinatore",
  "notifications_permission_banner.how_to_control": "Per riceve nutificazione quandu Mastodon ùn hè micca aperta, attivate e nutificazione nant'à l'urdinatore. Pudete decide quali tippi d'interazione anu da mandà ste nutificazione cù u buttone {icon} quì sopra quandu saranu attivate.",
  "notifications_permission_banner.title": "Ùn mancate mai nunda",
  "picture_in_picture.restore": "Rimette in piazza",
  "poll.closed": "Chjosu",
  "poll.refresh": "Attualizà",
  "poll.total_people": "{count, plural, one {# persona} other {# persone}}",
  "poll.total_votes": "{count, plural, one {# votu} other {# voti}}",
  "poll.vote": "Vutà",
  "poll.voted": "Avete vutatu per sta risposta",
  "poll.votes": "{votes, plural, one {# votu} other {# voti}}",
  "poll_button.add_poll": "Aghjunghje",
  "poll_button.remove_poll": "Toglie u scandagliu",
  "privacy.change": "Mudificà a cunfidenzialità di u statutu",
  "privacy.public.short": "Pubblicu",
  "refresh": "Attualizà",
  "relative_time.days": "{number}ghj",
  "relative_time.hours": "{number}o",
  "relative_time.just_now": "avà",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "oghji",
  "reply_indicator.cancel": "Annullà",
  "report.forward": "Trasferisce à {target}",
  "report.forward_hint": "U contu hè nant'à un'altru servore. Vulete ancu mandà una copia anonima di u signalamentu quallà?",
  "report.placeholder": "Altri cummenti",
  "report.submit": "Mandà",
  "report.target": "Signalamentu di {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search.placeholder": "Circà",
  "search_results.hashtags": "Hashtag",
  "search_results.statuses": "Statuti",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "Apre l'interfaccia di muderazione per @{name}",
  "status.admin_status": "Apre stu statutu in l'interfaccia di muderazione",
  "status.block": "Bluccà @{name}",
  "status.bookmark": "Segnalibru",
  "status.cancel_reblog_private": "Ùn sparte più",
  "status.cannot_reblog": "Stu statutu ùn pò micca esse spartutu",
  "status.copy": "Cupià ligame indè u statutu",
  "status.delete": "Toglie",
  "status.detailed_status": "Vista in ditagliu di a cunversazione",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.load_more": "Vede di più",
  "status.media_hidden": "Media piattata",
  "status.mention": "Mintuvà @{name}",
  "status.more": "Più",
  "status.mute": "Piattà @{name}",
  "status.mute_conversation": "Piattà a cunversazione",
  "status.open": "Apre stu statutu",
  "status.pin": "Puntarulà à u prufile",
  "status.read_more": "Leghje di più",
  "status.reblog": "Sparte",
  "status.reblogged_by": "{name} hà spartutu",
  "status.reblogs.empty": "Per avà nisunu hà spartutu u statutu. Quandu qualch'unu u sparterà, u so contu sarà mustratu quì.",
  "status.redraft": "Sguassà è riscrive",
  "status.remove_bookmark": "Toglie segnalibru",
  "status.reply": "Risponde",
  "status.replyAll": "Risponde à tutti",
  "status.report": "Palisà @{name}",
  "status.sensitive_warning": "Cuntinutu sensibile",
  "status.share": "Sparte",
  "status.show_less_all": "Ripiegà tuttu",
  "status.show_more_all": "Slibrà tuttu",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.unmute_conversation": "Ùn piattà più a cunversazione",
  "status.unpin": "Spuntarulà da u prufile",
  "tabs_bar.home": "Accolta",
  "tabs_bar.notifications": "Nutificazione",
  "time_remaining.days": "{number, plural, one {# ghjornu ferma} other {# ghjorni fermanu}}",
  "time_remaining.hours": "{number, plural, one {# ora ferma} other {# ore fermanu}}",
  "time_remaining.minutes": "{number, plural, one {# minuta ferma} other {# minute fermanu}} left",
  "time_remaining.moments": "Ci fermanu qualchi mumentu",
  "time_remaining.seconds": "{number, plural, one {# siconda ferma} other {# siconde fermanu}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Tindenze d'avà",
  "ui.beforeunload": "A bruttacopia sarà persa s'ellu hè chjosu Mastodon.",
  "units.short.billion": "{count}G",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Drag & drop per caricà un fugliale",
  "upload_button.label": "Aghjunghje un media",
  "upload_error.limit": "Limita di caricamentu di fugliali trapassata.",
  "upload_error.poll": "Ùn si pò micca caricà fugliali cù i scandagli.",
  "upload_form.edit": "Mudificà",
  "upload_progress.label": "Caricamentu...",
  "video.close": "Chjudà a video",
  "video.download": "Scaricà fugliale",
  "video.exit_fullscreen": "Caccià u pienu screnu",
  "video.expand": "Ingrandà a video",
  "video.fullscreen": "Pienu screnu",
  "video.hide": "Piattà a video",
  "video.pause": "Pausa",
  "video.play": "Lettura"
}
